export default __webpack_public_path__ + "static/media/resume.b496a79e.pdf";